import React from 'react'
import './admin-create-timesheet.css'
import AddNote from '../../CreateTimesheet/AddNote/AddNote'
import FamilyCard from '../../CreateTimesheet/FamilyCard/FamilyCard'
import axios from 'axios'
import { baseUrl } from '../../assets/Animations'

const AdminCreateTimesheet = (props) => {
    const [families, setFamilies] = React.useState([])
    const [note, setNote] = React.useState('')
    const [notesOpen, setNotesOpen] = React.useState(false)
    const [estimatedPay, setEstimatedPay] = React.useState(0)
    const [listOfFamiliesForTeachers, setListOfFamiliesForTeachers] = React.useState([])
    const [incomplete, setIncomplete] = React.useState(false)
    const [monthNumber, setMonthNumber] = React.useState(0)
    const [listOfTeachers, setListOfTeachers] = React.useState([])
    const [teacherId, setTeacherId] = React.useState('')
    const [selectedTeacher, setSelectedTeacher] = React.useState({})
    const [school, setSchool] = React.useState('')
    const [month, setMonth] = React.useState('')
    const [year, setYear] = React.useState()

    const tryToClose = (id) => {
        if(id === 'admin-create-timesheet__wrapper') {
            props.setAdminCreateTimesheet(false)
        }
    }

    const myToken = localStorage.getItem('token')
    const myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }

    React.useEffect(() => {
        // const getTeachersFamilies = async () => {
        //     let fixedName = encodeURIComponent(props.userData.Name.trim())
        //     //let REPLACEWITHFIXEDNAME = 'Andi%20Bonato'
        //     let res = await axios.get(`${baseUrl}/teachersfamilies/${props.userData.TeacherID}`, myHeader)
        //     setListOfFamiliesForTeachers(res.data)
        // }
        // getTeachersFamilies()
        // calculateEstimatedPay()
        //createDateSettings()
    },[])

    React.useEffect(() => {
        const getTeachers = async () => {
            axios.get(`${baseUrl}/teachersbyschool/${school}`, myHeader)
            .then((res) => {
                setListOfTeachers(res.data)
            })
            .catch((err) => {
                console.log(err)
            })
        }
        getTeachers()
    }, [school])

    React.useEffect(() => {
        if(families.length > 0) {
            if(document.getElementById('create-timesheet__submit-btn')) {
                document.getElementById('create-timesheet__submit-btn').style.backgroundColor = "rgba(0, 128, 0, 0.747)"
            }
        } else {
            if(document.getElementById('create-timesheet__submit-btn')) {
                document.getElementById('create-timesheet__submit-btn').style.backgroundColor = 'rgba(128, 128, 128, 0.336)'
            }
        }
        // if(props.families) {
        //     setFamilies(props.families)
        // }
        calculateEstimatedPay()

        //CHECK IF EVERYTHING IS FILLED OUT
        for(let i = 0; i < families.length; i++) {
            let theFamily = families[i]
            for(let i = 0; i < theFamily.lessons.length; i++) {
                if(theFamily.lessons[i].studentName === '' || theFamily.lessons[i].lessonLength === 0 || theFamily.lessons[i].date === "") {
                    setIncomplete(true)
                    return
                } else {
                    setIncomplete(false)
                }    
            }
            for(let i = 0; i < theFamily.cancellations.length; i++) {
                if(theFamily.cancellations[i].student === '' || theFamily.cancellations[i].cancellor === '0' || (theFamily.cancellations[i].lessonLength === 0 && theFamily.cancellations[i].cancellor === "student less than 24hrs") || theFamily.cancellations[i].date === "") {
                    setIncomplete(true)
                    return
                } else {
                    setIncomplete(false)
                }
            }
            for( let i = 0; i < theFamily.extras.length; i++) {
                if(theFamily.extras[i].description === '' || theFamily.extras[i].amount === 0) {
                    setIncomplete(true)
                    return
                } else {
                    setIncomplete(false)
                }
            }
        }
    }, [families])

    React.useEffect(() => {
        createMonthNumber()
    }, [month])

    React.useEffect(() => {
        for(let i = 0; i < listOfTeachers.length; i++) {
            if(listOfTeachers[i].TeacherID === teacherId) {
                setSelectedTeacher(listOfTeachers[i])
            }
        }
    }, [teacherId])

    const createMonthNumber = () => {
        if(month === 'January') {
            setMonthNumber(1)
        } else if (month === 'February') {
            setMonthNumber(2)
        } else if (month === 'March') {
            setMonthNumber(3)
        } else if (month === 'April') {
            setMonthNumber(4)
        } else if (month === 'May') {
            setMonthNumber(5)
        } else if (month === 'June') {
            setMonthNumber(6)
        } else if (month === 'July') {
            setMonthNumber(7)
        } else if (month === 'August') {
            setMonthNumber(8)
        } else if (month === 'September') {
            setMonthNumber(9)
        } else if (month === 'October') {
            setMonthNumber(10)
        } else if (month === 'November') {
            setMonthNumber(11)
        } else if (month === 'December') {
            setMonthNumber(12)
        }
    }

    const calculateEstimatedPay = () => {
        let total = 0
        let minutesTaught = 0
        let allExtras = 0
        for(let i = 0; i < families.length; i++) {
            let fam = families[i]
            for(let i = 0; i < fam.lessons.length; i++) {
                minutesTaught = Number(minutesTaught) + Number(fam.lessons[i].lessonLength)
            }
            for(let i = 0; i < fam.cancellations.length; i++) {
                if(fam.cancellations[i].cancellor === 'student less than 24hrs') {
                    minutesTaught = Number(minutesTaught) + Number(fam.cancellations[i].lessonLength)
                }
            }
            for(let i = 0; i < fam.extras.length; i++) {
                allExtras = Number(allExtras) + Number(fam.extras[i].amount)
            }
        }
        setEstimatedPay(((minutesTaught/60) * Number(selectedTeacher.Rate)) + allExtras)
    }

    //ADD FAMILY
    const addFamily = () => {
        let newFamily = {
            id: Math.random().toString(16).slice(2),
            familyName: '',
            lessons: [],
            cancellations: [],
            familyWaveId: '',
            listOfFamilyStudents: [],
            email: '',
            school: '',
            extras: [],
            familyNameEntered: false
        }
        setFamilies(prev => [...prev, newFamily])
    }
    //CHANGE FAMILY NAME
    const changeFamilyName = (index, familyObj) => {
        // let theFamiliesStudents = []
        // let theWaveId = ''
        // let theEmail = ''
        // let theSchool = ''
        // for(let i = 0; i < listOfFamiliesForTeachers.length; i++) {
        //     if(listOfFamiliesForTeachers[i].familyName === value) {
        //         theFamiliesStudents = listOfFamiliesForTeachers[i].students
        //         theWaveId = listOfFamiliesForTeachers[i].waveCustomerId
        //         theEmail = listOfFamiliesForTeachers[i].primaryEmail
        //         theSchool = listOfFamiliesForTeachers[i].school.toLowerCase()
        //     }
        // }
        let newArr = [...families]
        if(familyObj.familyName){
            newArr[index].familyName = familyObj.familyName
        }
        if(familyObj.students){
            newArr[index].listOfFamilyStudents = familyObj.students
        }
        if(familyObj.waveCustomerId){
            newArr[index].familyWaveId = familyObj.waveCustomerId
        }
        if(familyObj.primaryEmail){
            newArr[index].email = familyObj.primaryEmail
        }
        if(familyObj.school){
            newArr[index].school = familyObj.school
        }

        setFamilies(newArr)

    }
    const autoOpenFamilyCardWhenNameIsSelected = (index, value) => {
        if(value === '*') {
            changeFamilyName(index, value)
        } else {
            changeFamilyName(index, value)
            submitLastName(index)
        }
    }
    const submitLastName = (index) => {
        let newArr = [...families]
        newArr[index].familyNameEntered = true
        setFamilies(newArr)
    }
    //REMOVE FAMILY
    const removeFamily = (id) => {
        setFamilies(families.filter(fam => fam.id !== id))
    }
    //ADD LESSON
    const addLesson = index => {
        let newLesson = {
            id: Math.random().toString(16).slice(2),
            studentName: '',
            lessonLength: 0,
            studentRate: 0,
            studentAllRates: {15: 0, 30: 0, 45: 0, 60: 0},
            date: '',
            enterNameManually: false
        }
        let newArr = [...families]
        newArr[index].lessons.push(newLesson)
        setFamilies(newArr)
    }
    const editLesson = (index1, index2, value, key) => {
        let arrayOfFamiliesOnTheTimesheet = [...families]
        arrayOfFamiliesOnTheTimesheet[index1].lessons[index2][key] = value
        if(key === 'studentName') {
            for(let i = 0; i < arrayOfFamiliesOnTheTimesheet.length; i++) {
                if(arrayOfFamiliesOnTheTimesheet[i].familyName === arrayOfFamiliesOnTheTimesheet[index1].familyName) {
                    let theFamiliesStudents = arrayOfFamiliesOnTheTimesheet[i].listOfFamilyStudents
                    for(let i = 0; i < theFamiliesStudents.length; i++) {
                        if(theFamiliesStudents[i].studentName === value) {
                            arrayOfFamiliesOnTheTimesheet[index1].lessons[index2].studentRate = theFamiliesStudents[i].lessonRate
                            arrayOfFamiliesOnTheTimesheet[index1].lessons[index2].studentAllRates = theFamiliesStudents[i].allRates
                        }
                    }
                }
            }
        }
        if(value === '*') {
            arrayOfFamiliesOnTheTimesheet[index1].lessons[index2][key] = ''
            arrayOfFamiliesOnTheTimesheet[index1].lessons[index2].enterNameManually = true
        }
        setFamilies(arrayOfFamiliesOnTheTimesheet)
    }
    const editCancellation = (index1, index2, value, key) => {
        let newArr = [...families]
        newArr[index1].cancellations[index2][key] = value
        if(value === '*') {
            newArr[index1].cancellations[index2][key] = ''
            newArr[index1].cancellations[index2].enterNameManually = true
        }
        setFamilies(newArr)
    }
    //REMOVE LESSON
    const removeLesson = (index, lessonId) => {
        let newArr = [...families]
        newArr[index].lessons = newArr[index].lessons.filter(less => less.id !== lessonId)
        setFamilies(newArr)
    }

    //ADD CANCELLATION
    const addCancellation = index => {
        let newLesson = {
            id: Math.random().toString(16).slice(2),
            student: '',
            cancellor: '0',
            lessonLength: 0,
            date: '',
            enterNameManually: false
        }
        let newArr = [...families]
        newArr[index].cancellations.push(newLesson)
        setFamilies(newArr)
    }
    //REMOVE CANCELLATION
    const removeCancellation = (index, lessonId) => {
        let newArr = [...families]
        newArr[index].cancellations = newArr[index].cancellations.filter(less => less.id !== lessonId)
        setFamilies(newArr)
    }
    const addExtra = (index) => {
        let newExtra = {
            id: Math.random().toString(16).slice(2),
            description: '',
            amount: 0
        }
        let newArr = [...families]
        newArr[index].extras.push(newExtra)
        setFamilies(newArr)
    }
    const editExtra = (index1, index2, value, key) => {
        let newArr = [...families]
        newArr[index1].extras[index2][key] = value
        setFamilies(newArr)
    }
    const removeExtra = (index, lessonId) => {
        let newArr = [...families]
        newArr[index].extras = newArr[index].extras.filter(ex => ex.id !== lessonId)
        setFamilies(newArr)
    }

    const submitTimesheet = async () => {
        let teachersTime = {
            timesheetId: Math.random().toString(16).slice(2),
            teacherId: selectedTeacher.TeacherID,
            teacherName: selectedTeacher.Name,
            families: families,
            status: 'submitted',
            note: note,
            submitDate: new Date(),
            monthYear: `${month}/${year}`,
            teacherRate: selectedTeacher.Rate,
            school: selectedTeacher.School,
            email: selectedTeacher.Email,
            monthNumber: monthNumber,
            year: year

        }
        axios.post(`${baseUrl}/teachertimesheet`, {
            teacherTimesheet: teachersTime
        }, myHeader)
        .then((res) => {
            props.setTimesheets(prev => [...prev, res.data])
            // props.setOpenUpTheTimesheet(false)
            // props.setThankYouForSubmitting(true)
            // props.setTryingToSubmitTimesheet(false)
            props.setAdminCreateTimesheet(false)
        })
        .catch((err) => {
            console.log(err)
            console.log('oops there was an error')
        })
    }

    return(
        <div id='admin-create-timesheet__wrapper' className='admin-create-timesheet__wrapper' onClick={(e) => tryToClose(e.target.id)}>
            <div className="create-timesheet">
                {notesOpen && <AddNote setNotesOpen={setNotesOpen} note={note} setNote={setNote} />}
                <div className="another-x-wrapper">
                    <h3 className="close-create-timesheet-x" onClick={() => props.setAdminCreateTimesheet(false)}>X</h3>
                </div>
                <h1>Create Timesheet</h1>
                <div>
                    <select className='admin-create-timesheet__select-school' value={school} onChange={(e) => setSchool(e.target.value)}>
                        <option value="" default>Select School</option>
                        <option value="mma">Mountainside</option>
                        <option value="lsma">Lakeside</option>
                        <option value="tma">Treeside</option>
                        <option value="mor">Morningside</option>
                        <option value="psma">Parkside</option>
                    </select>
                </div>
                <div>
                    <select className='admin-create-timesheet__select-teacher' onChange={(e) => setTeacherId(e.target.value)}>
                        <option value="" default>Choose Teacher</option>
                        {listOfTeachers.map((teacher) => <option value={teacher.TeacherID}>{teacher.Name}</option>)}
                    </select>
                </div>
                <select className="month-selector" value={month} onChange={(e) => setMonth(e.target.value)}>
                    <option value="" default>Month</option>
                    <option value="January">January</option>
                    <option value="February">February</option>
                    <option value="March">March</option>
                    <option value="April">April</option>
                    <option value="May">May</option>
                    <option value="June">June</option>
                    <option value="July">July</option>
                    <option value="August">August</option>
                    <option value="September">September</option>
                    <option value="October">October</option>
                    <option value="November">November</option>
                    <option value="December">December</option>
                </select>
                <select className="year-selector" value={year} onChange={(e) => setYear(parseInt(e.target.value))}>
                    <option value="" default>Year</option>
                    <option value="2021">2021</option>
                    <option value="2022">2022</option>
                    <option value="2023">2023</option>
                    <option value="2024">2024</option>
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                    <option value="2027">2027</option>
                    <option value="2028">2028</option>
                    <option value="2029">2029</option>
                    <option value="2030">2030</option>
                </select>
                <div className="family-card-section">
                    {families.map((fam, index) => 
                        <FamilyCard
                            key={fam.id}
                            index={index}
                            fam={fam}
                            reviewing={props.reviewing}
                            timesheet={props.timesheet}
                            addWaveIdToFamilyInformation={props.addWaveIdToFamilyInformation}
                            listOfFamilies={props.listOfFamilies}
                            listOfFamiliesForTeachers={listOfFamiliesForTeachers}
                            month={monthNumber}
                            changeFamilyName={changeFamilyName}
                            autoOpenFamilyCardWhenNameIsSelected={autoOpenFamilyCardWhenNameIsSelected}
                            removeFamily={removeFamily}
                            addLesson={addLesson}
                            removeLesson={removeLesson}
                            addCancellation={addCancellation}
                            removeCancellation={removeCancellation}
                            editLesson={editLesson}
                            submitLastName={submitLastName}
                            editCancellation={editCancellation}
                            addExtra={addExtra}
                            editExtra={editExtra}
                            removeExtra={removeExtra}
                        />
                    )}
                </div>
                <div className="add-family" onClick={() => addFamily()}>+ Add Family</div>
                <div className="create-timesheet-bottom-sections">
                    <div className="create-timesheet__add-note" onClick={() => setNotesOpen(true)}>+ Note</div>
                    {note !== '' && <div className="create-timesheet-pencil"></div>}
                    <h3 className="create-timesheet__estimated-pay">Estimate Pay: ${estimatedPay}</h3>
                    <div>
                        <div className="create-timesheet__submit-timesheet" onClick={() => submitTimesheet()} id="create-timesheet__submit-btn">Submit Timesheet</div>
                        {incomplete && <p style={{color: "red"}}>Please Fill Out Everything</p>}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default AdminCreateTimesheet;